/**
 * リソース詳細ページ（スライドなど）
 */
import { useParams } from 'react-router-dom';

function ResourceDetail() {
  const { id } = useParams();  // URLからリソースIDを取得

  // TODO: idを使ってAPIからリソースデータを取得

  return (
    <div>
      <h1>リソース詳細 (ID: {id})</h1>
      {/* TODO: リソースの詳細を表示 */}
    </div>
  );
}

export default ResourceDetail;
